import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Section 1 : À propos */}
                <div className="footer-section">
                    <h3 className="footer-title">
                        <span className="footer-icon">🎓</span>
                        VTYM Consulting Group
                    </h3>
                    <p className="footer-description">
                        Plateforme de formation professionnelle en douane et commerce international.
                        Développez vos compétences avec nos formations certifiantes.
                    </p>
                </div>

                {/* Section 2 : Liens rapides */}
                <div className="footer-section">
                    <h4 className="footer-subtitle">Liens rapides</h4>
                    <ul className="footer-links">
                        <li><Link to="/">Accueil</Link></li>
                        <li><Link to="/formations">Nos formations</Link></li>
                        <li><Link to="/dashboard">Mon espace</Link></li>
                        <li><Link to="/login">Connexion</Link></li>
                    </ul>
                </div>

                {/* Section 3 : Contact */}
                <div className="footer-section">
                    <h4 className="footer-subtitle">Contact</h4>
                    <ul className="footer-contact">
                        <li>📧 info@vtymconsultinggroup.com</li>
                        <li>📞 +225 27 22 53 59 55 / 07 02 38 28 55</li>
                        <li>📍 Abidjan,Palmeraie programme 5 Côte d'Ivoire</li>
                    </ul>
                </div>

                {/* Section 4 : Réseaux sociaux */}
                <div className="footer-section">
                    <h4 className="footer-subtitle">Suivez-nous</h4>
                    <div className="footer-social">
                        <a href="https://www.linkedin.com/company/vtymconsultinggroup/?viewAsMember=true" className="social-link" aria-label="LinkedIn">💼</a>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="footer-bottom">
                <p>© 2026 VTYM Consulting Group. Tous droits réservés.</p>
            </div>
        </footer>
    );
}

export default Footer;
